import React, { useState } from 'react';
import AdminPage from './AdminPage';
import '../../styles/admin.css';

// Simple admin login for basic access control
const AdminIndex: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  
  // Very simple auth - in a real app, use proper auth mechanisms
  const adminPassword = import.meta.env.VITE_ADMIN_PASSWORD || 'bj@Ue#puM5nJs+f+XqhFYK';
  
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (password === adminPassword) {
      setIsAuthenticated(true);
      setError(null);
    } else {
        // wer das liest ist leise xD (Ist ja nichts Geheimes)
        // Würde mich aber tatsächlich intressieren. Mailt mir gerne an max@dyren.de
      setError('Falsches Passwort. Bitte versuchen Sie es erneut.');
    }
  };
  
  if (isAuthenticated) {
    return <AdminPage />;
  }
  
  return (
    <div className="admin-login">
      <div className="login-container">
        <h1>Admin-Anmeldung</h1>
        
        <form onSubmit={handleLogin}>
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="password">Passwort:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Admin-Passwort eingeben"
              required
            />
          </div>
          
          <button type="submit" className="login-button">
            Anmelden
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminIndex;